import InterfaceSettingToolBox from '@streamlinehq/streamlinehq/img/streamline-micro-line/interface-essential/setting/interface-setting-tool-box.svg';
import ShoppingStore2 from '@streamlinehq/streamlinehq/img/streamline-micro-line/money-shopping/building-store/shopping-store-2.svg';
import ShoppingCart3 from '@streamlinehq/streamlinehq/img/streamline-micro-line/money-shopping/cart/shopping-cart-3.svg';
import InterfaceTextFormattingListBullets from '@streamlinehq/streamlinehq/img/streamline-mini-line/interface-essential/text-formatting/interface-text-formatting-list-bullets.svg';
import InterfaceWeatherSnowFlake from '@streamlinehq/streamlinehq/img/streamline-mini-line/interface-essential/weather/interface-weather-snow-flake.svg';
import { ModelEntityType } from '../../../../common/model/input/types';

export function getModelEntityStreamlineIcon(type: ModelEntityType) {
  switch (type) {
    case ModelEntityType.PRODUCT:
    case ModelEntityType.MIXIN:
      return <ShoppingCart3 />;
    case ModelEntityType.PHENOMENON:
      return <InterfaceWeatherSnowFlake />;
    case ModelEntityType.COMPANY:
      return <ShoppingStore2 />;
    case ModelEntityType.GROUP:
      return <InterfaceTextFormattingListBullets />;
    case ModelEntityType.PORTFOLIO:
      return <InterfaceSettingToolBox />;
  }
}

export function getModelEntitySvgIcon(type: ModelEntityType) {
  switch (type) {
    case ModelEntityType.PRODUCT:
    case ModelEntityType.MIXIN:
      return ShoppingCart3;
    case ModelEntityType.PHENOMENON:
      return InterfaceWeatherSnowFlake;
    case ModelEntityType.COMPANY:
      return ShoppingStore2;
    case ModelEntityType.GROUP:
      return InterfaceTextFormattingListBullets;
    case ModelEntityType.PORTFOLIO:
      return InterfaceSettingToolBox;
  }
}
